/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const CheckWire = ({ color = '#92D3F3', ...props }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.66655 12.8948L12.1332 16.3614"
        stroke="#92D3F3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="1"
        y1="-1"
        x2="10.8178"
        y2="-1"
        transform="matrix(-0.679844 0.733357 -0.726359 -0.687315 19.25 7.80005)"
        stroke="#92D3F3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

CheckWire.propTypes = {
  color: string,
  height: number,
}

export default CheckWire
